import { forwardRef, type PropsWithChildren } from "react";

import clsx from "clsx";

interface Props {
  isActive: boolean;
}

export const RestMenuButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Props>
>(({ isActive, ...props }, ref) => {
  return (
    <button
      {...props}
      ref={ref}
      className={clsx(
        "text-sm text-v2-action font-semibold flex items-center gap-2 text-nowrap",
        {
          "h-8 border-b border-v2-light mx-1": !isActive,
          "h-9 rounded-md px-3 border border-v2-light bg-v2-action-secondary":
            isActive,
          "shadow-[2px_2px_4px_0px_rgba(0,0,0,0.10)_inset]": isActive,
        },
      )}
    />
  );
});
